(() => {
  const initialise = () => document.querySelectorAll('[data-fsk-finder]').forEach(root => {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = 'true';
    const fields = Object.fromEntries([...root.querySelectorAll('[data-finder-field]')].map(el => [el.dataset.finderField, el]));
    const results = root.querySelector('[data-finder-results]');
    const summary = root.querySelector('[data-finder-summary]');
    const viewAll = root.querySelector('[data-finder-view-all]');
    const base = root.dataset.collectionUrl;
    const names = {league: 'filter.p.m.custom.league', size: 'filter.p.m.custom.size', kit: 'filter.p.m.custom.kit_type'};
    let generation = 0;
    let controller;
    let filters = [];
    let ready = false;
    const message = text => { results.replaceChildren(Object.assign(document.createElement('p'), {textContent: text})); };
    const paramsFor = () => {
      const params = new URLSearchParams();
      for (const [key, param] of Object.entries(names)) {
        if (!fields[key].value) continue;
        const filter = filters.find(f => f.param === param);
        if (!filter || !filter.values.some(v => v.value === fields[key].value)) throw new Error('Unavailable filter');
        params.set(param, fields[key].value);
      }
      if (fields.price.value) {
        params.set('filter.v.price.gte', '0');
        params.set('filter.v.price.lte', fields.price.value);
      }
      return params;
    };
    const updateLink = params => {
      const query = params.toString();
      viewAll.href = query ? `${base}?${query}` : base;
    };
    const updateSummary = () => {
      const parts = Object.values(fields).filter(f => f.value).map(f => f.selectedOptions[0].textContent);
      if (summary) summary.textContent = parts.length ? `Current filters: ${parts.join(' • ')}` : '';
    };
    async function load() {
      if (!ready) return;
      const request = ++generation;
      controller?.abort();
      controller = new AbortController();
      updateSummary();
      message('Loading matching shirts…');
      results.setAttribute('aria-busy', 'true');
      try {
        const params = paramsFor();
        updateLink(params);
        params.set('section_id', 'fsk-finder-results');
        const response = await fetch(`${base}?${params}`, {credentials: 'same-origin', signal: controller.signal});
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (request !== generation) return;
        const incoming = doc.querySelector('.fsk-finder-results-wrap');
        if (!incoming) throw new Error('Missing results');
        // Confirm Shopify recognised every selected filter before showing its results.
        const returned = JSON.parse(incoming.querySelector('[data-finder-filters]').textContent);
        for (const param of params.keys()) {
          if (Object.values(names).includes(param) && !returned.some(f => f.param === param && f.values.some(v => v.value === params.get(param) && v.active))) throw new Error('Unavailable filter');
        }
        incoming.querySelector('[data-finder-filters]').remove();
        incoming.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
        results.replaceChildren(incoming);
        const more = results.querySelector('.fsk-view-all-matches');
        if (more) more.href = viewAll.href;
        document.dispatchEvent(new Event('shopify:section:load'));
      } catch (error) {
        if (error.name !== 'AbortError' && request === generation) message('Matching shirts could not be loaded. Please try again.');
      } finally {
        if (request === generation) results.removeAttribute('aria-busy');
      }
    }
    Object.values(fields).forEach(field => field.addEventListener('change', load));
    root.querySelector('[data-finder-clear]').addEventListener('click', () => {
      ++generation;
      controller?.abort();
      Object.values(fields).forEach(field => field.value = '');
      results.removeAttribute('aria-busy');
      updateSummary();
      updateLink(new URLSearchParams());
      message('Choose your options to find matching shirts.');
    });
    viewAll.addEventListener('click', event => { if (!ready) event.preventDefault(); });
    Object.values(fields).forEach(f => f.disabled = true);
    message('Loading filter options…');
    fetch(`${base}?section_id=fsk-finder-results`, {credentials: 'same-origin'})
      .then(response => { if (!response.ok) throw new Error(); return response.text(); })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        filters = JSON.parse(doc.querySelector('[data-finder-filters]').textContent);
        for (const [key, param] of Object.entries(names)) {
          const filter = filters.find(f => f.param === param);
          if (!filter) throw new Error('Unavailable filter');
          const field = fields[key];
          const placeholder = field.options[0].cloneNode(true);
          field.replaceChildren(placeholder, ...filter.values.map(v => new Option(v.label, v.value)));
        }
        ready = true;
        Object.values(fields).forEach(f => f.disabled = false);
        message('Choose your options to find matching shirts.');
      }).catch(() => message('The shirt finder is temporarily unavailable. Please browse the collections.'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
